import { render, staticRenderFns } from "./ModalVerDados.vue?vue&type=template&id=7d259a1b&"
import script from "./ModalVerDados.vue?vue&type=script&lang=ts&"
export * from "./ModalVerDados.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports